import { IUserParam } from '../../models/userparam.model';
import { UserParamAction, UserParamActionType } from '../actions/userparam.action';

export const UserParamReducer = (
    state: IUserParam[] = new Array<IUserParam>(),
    action: UserParamAction
) => {
    switch (action.type) {
        case UserParamActionType.FETCH_USERPARAMS:
            return action.userParams;
        case UserParamActionType.ADD_USERPARAM:
            return [
                ...state,
                action.userParam
            ];
        case UserParamActionType.SET_USERPARAM_TO_COMPLETE:
            return state.map((userParam: IUserParam) => {
                if (userParam.id === action.id) {
                    userParam = { ...userParam, complete: true };
                }
                return userParam;
            });
        case UserParamActionType.DELETE_USERPARAM:
            return state.filter((userParam: IUserParam) =>
                userParam.id !== action.id
            );
        default:
            return state;
    }
}